// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.js-vl-select[data-type*=select-one] .vl-input-field .vl-select__item--selectable {
  display: inherit;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.js-vl-select .vl-select__list--dropdown {
  z-index: 3 !important;
}
.js-vl-select[data-type*=select-one] .vl-select__list .vl-select__item--selectable {
  line-height: normal;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
